import { BaseUseCase } from "../UseCaseBase";
class OfferingsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getHomePageOfferingsData();
    }
}
export default OfferingsUseCase;
